/**
 * Update Component Fill
 *
 * @param component_name Component Name
 * @param component Component
 * @param options Options
 */
function updateComponentPattern(component_name, component, options) {
  try {
    if (!isNaN(component_name)) return;
    const patternID = `${component_name}_image`;
    const patternElement = this.svg.findOne(`[id^="${component_name}_image"]`)
    if (patternElement) patternElement.remove();

    const patternData = component.pattern_data || options.pattern_data;

    this.insertPattern({
      width: patternData.w || patternData.width,
      height: patternData.h || patternData.height,
      id: patternID,
      patternUnits: "userSpaceOnUse",
    });

    this.insertImage({
      href: patternData.href,
      width: patternData.w || patternData.width,
      height: patternData.h || patternData.height,
      elementId: patternID,
    });

    const targetGraphicComponent = this.svg.findOne(`#${component_name}`);
    targetGraphicComponent && targetGraphicComponent.fill(`url(#${patternID})`);
  } catch (err) {
    throw new Error("Error updating pattern fill for " + component_name);
  }
}

module.exports = updateComponentPattern;
